import { isSuccess } from '@/context/services/type';
import { isCommonError } from '@/libs/typeguard/isError';
import {
  AdminInvoiceReportBusinessDocumentResponse,
  useGetAdminInvoiceReportBusinessDocumentSuspense,
} from 'ap-openapi';
import { useMemo } from 'react';

export type UseAdminInvoiceReportBusinessDocumentResult = {
  data?: AdminInvoiceReportBusinessDocumentResponse;
  error?: {
    messages?: string[];
    code?: string;
  };
};

export const useAdminInvoiceReportBusinessDocumentService = (
  businessDocumentId: string
): UseAdminInvoiceReportBusinessDocumentResult => {
  const { data, error } = useGetAdminInvoiceReportBusinessDocumentSuspense(
    businessDocumentId,
    {
      query: {
        queryKey: ['adminInvoiceReportBusinessDocument', businessDocumentId],
      },
    }
  );

  if (error) {
    throw error;
  }

  const body = data?.data;
  const status = data?.status;
  const isSuccessStatus = isSuccess(status);

  return useMemo(() => {
    if (!isSuccessStatus) {
      if (typeof body === 'object' && isCommonError(body)) {
        return {
          data: undefined,
          error: {
            messages: body?.messages,
            code: status?.toString(),
          },
        };
      }
      return {
        data: undefined,
        error: {
          messages: undefined,
          code: status?.toString(),
        },
      };
    }
    return {
      data: body,
      error: undefined,
    };
  }, [body, isSuccessStatus, status]);
};
